/**
 * `/api/rewards` wrapper — the per-wallet dashboard summary.
 *
 * Envelope is `{ success, data }` / `{ success: false, error }`, inherited from
 * the retired `get-rewards-info` Cloudflare Worker. The union is returned as-is
 * rather than being flattened to a throw: the dashboard distinguishes "no data
 * yet" from "request failed".
 */
import type { GetRewardsInfoResponse, RewardsInfoQuery } from "@swarm/shared/schemas";
import { getRewardsInfoResponseSchema } from "@swarm/shared/schemas";

import { routes } from "@/hooks/useRoutes/useRoutes";

import { apiRequest } from "./client";

/** Lifetime tokens, cashback, pool share and tier boost for one wallet. */
export const getRewardsInfo = (query: RewardsInfoQuery): Promise<GetRewardsInfoResponse> =>
  apiRequest(routes.api.rewards.info(query), getRewardsInfoResponseSchema);
